import React, { useState } from 'react';
import { Modal, Form, Input, Switch, message } from 'antd';

const AdminFormModal = ({ open, admin, companyId, onCancel, onOk }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isEdit = !!admin;

  return (
    <Modal
      title={isEdit ? '编辑管理员' : '新增管理员'}
      open={open}
      onCancel={onCancel}
      onOk={() => {
        form.validateFields().then(async (values) => {
          setLoading(true);
          try {
            await onOk(values);
            form.resetFields();
          } finally {
            setLoading(false);
          }
        });
      }}
      confirmLoading={loading}
      destroyOnClose
      afterOpenChange={(visible) => {
        if (visible && isEdit) {
          form.setFieldsValue({
            username: admin.username,
            nickname: admin.nickname,
            is_active: admin.is_active === 1,
          });
        }
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="username" label="用户名" rules={[{ required: true, message: '请输入用户名' }]}>
          <Input disabled={isEdit} placeholder="请输入用户名" />
        </Form.Item>
        {!isEdit && (
          <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }, { min: 6, message: '密码至少6位' }]}>
            <Input.Password placeholder="请输入密码" />
          </Form.Item>
        )}
        <Form.Item name="nickname" label="昵称">
          <Input placeholder="请输入昵称" />
        </Form.Item>
        {isEdit && (
          <Form.Item name="is_active" label="启用状态" valuePropName="checked">
            <Switch checkedChildren="启用" unCheckedChildren="禁用" />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default AdminFormModal;
